/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Table, Thead, Tr, Th, Tbody, Td } from "@chakra-ui/react";

import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";

const LedgerTable = ({ ledgerData,total }) => {
  return (
    <>
      <Table>
        <Thead className="heading">
          <Tr>
            <Th>Date</Th>
            <Th>Particular</Th>
            <Th>Vch Type</Th>
            <Th>Pr No.</Th>
            <Th>Debit</Th>
            <Th>Credit</Th>
          </Tr>
        </Thead>
        <Tbody className="mt-3">
          {ledgerData && ledgerData?.length ? ledgerData?.map((item) => {
            const spent = item?.spent;
            const gst = item?.gstDetails;
            const tds = item?.tdsDetails;
            const category = item?.category
            return (
              <>
              <Tr className="pt-3">
                <Td className="top-fixed">
                   {dateTimeFormat(item?.creditDate)} By
                </Td>
                <Td>
                  <p className="bold-text">{item?.poNo} {gst?.percentage ? `(${gst?.percentage}%)`:""}</p>
                  {gst?.cgst ? <p className="bold-text">CGST</p> : ""}
                  {gst?.sgst ? <p className="bold-text">SGST</p>:""}
                  {gst?.igst ? <p className="bold-text">IGST</p>: ""}
                  {tds?.amount ? <p className="bold-text">Tds {tds?.isTdsPo ? `(${tds?.tdsPO})`:""}</p>: ""}
                </Td> 
                <Td>
                  <p className="bold-text">Journal</p>
                  {gst?.cgst ? <p className="bold-text"><Box display="flex">{formatAmountInINR(gst?.cgst)} Dr</Box></p>:""}
                  {gst?.sgst ? <p className="bold-text"><Box display="flex">{formatAmountInINR(gst?.sgst)} Dr</Box></p> : ""}
                  {gst?.igst ? <p className="bold-text"><Box display="flex">{formatAmountInINR(gst?.igst)} Dr</Box></p> : ""}
                  {tds?.amount ? <p className="bold-text"><Box display="flex">{formatAmountInINR(tds?.amount)} Cr</Box></p> : ""}
                </Td>
                <Td className="top-fixed">{item?.poNo}</Td>

                <Td>{category === 'tds' ? formatAmountInINR(item?.creditAmount) : ''}</Td>
                <Td className="amount"><p>{category !== 'tds'?formatAmountInINR(item?.creditAmount):""}</p></Td>
              </Tr>
              {spent && category !== 'tds' && spent.length > 0 && spent.map((s, index) => (
             <Tr key={index}>
             <Td>
               {dateTimeFormat(s?.date)} To
             </Td>
             <Td>
               <p className="bold-text">{s?.bank} {s?.refNo ? `(${s?.refNo})` : ""}</p>
             </Td>
             <Td>
               <p className="bold-text">Payment</p>
             </Td>
             <Td></Td>
             <Td className="amount"><p>{formatAmountInINR(s?.amount)}</p></Td>
             <Td></Td>
           </Tr>
              ))}
              </>
            );
          }):""}
          <Tr className="">
            <Td></Td>
            <Td></Td>
            <Td></Td>
            <Td></Td>
            <Td className="border-top">{total?.totalDebit ? formatAmountInINR(total?.totalDebit): Number(0).toFixed(2)}</Td>
            <Td className="border-top">{total?.totalCredit ? formatAmountInINR(total?.totalCredit) : Number(0).toFixed(2)}</Td>
          </Tr>
          <Tr className="mt-2">
            <Td>By</Td>
            <Td>
              <p className="bold-text">Closing Balance</p>
            </Td>
            <Td></Td>
            <Td></Td>
            <Td className="border-bottom">{total?.closingBal > 0 ? formatAmountInINR(total?.closingBal) :''}</Td>
            <Td className="border-bottom">{total?.closingBal < 0 ? formatAmountInINR(Math.abs(total?.closingBal)) :Number(0).toFixed(2)}</Td>
          </Tr>
          <Tr className="mt-2">
            <Td></Td>
            <Td></Td>
            <Td></Td>
            <Td></Td>
            <Td className="border-bottom bold-text">{total?.closingBal > 0 ? formatAmountInINR(total?.totalDebit + total?.closingBal) :total?.totalDebit ? formatAmountIndianRupees(total?.totalDebit):Number(0).toFixed(2)}</Td>
            <Td className="border-bottom bold-text">{total?.closingBal < 0 ? formatAmountInINR(total?.totalCredit + Math.abs(total?.closingBal)) :total?.totalCredit ? formatAmountIndianRupees(total?.totalCredit):Number(0).toFixed(2)}</Td>
          </Tr>
        </Tbody>
      </Table>
    </>
  );
};

export default LedgerTable;
